module.exports = __webpack_public_path__ + "static/media/ellipse_black.a13f8229.svg";